import React from "react";
import Item from "./Item";
import { DividerProps } from "./types";

const Divider: React.FC<DividerProps> = ({ handleClose }) => (
  <Item className="quick-view__divider" handleClose={handleClose} />
);

export default Divider;
